import api from './api';

export const getAgendaBlocks = ()        => api.get('/ideal-agenda').then(r => r.data);
export const getTodayBlocks  = (energy)  => api.get('/ideal-agenda/today', {
  params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone, energy: energy || undefined },
}).then(r => r.data);
export const createBlock     = (data)    => api.post('/ideal-agenda', data).then(r => r.data);
export const updateBlock     = (id, data)=> api.put(`/ideal-agenda/${id}`, data).then(r => r.data);
export const deleteBlock     = (id)      => api.delete(`/ideal-agenda/${id}`).then(r => r.data);
export const toggleCompletion = (id, completed) => api.post(`/ideal-agenda/${id}/complete`, { completed }, {
  params: { tz: Intl.DateTimeFormat().resolvedOptions().timeZone },
}).then(r => r.data);
